import React from 'react'
import { Card } from 'reactstrap'
import FeesTable from './FeesTable'

const FeesManagement = () => {

  return (
    <Card className='p-3'>
      <FeesTable  />
    </Card>
  )
}

export default FeesManagement